<template>
  <div class="mainPageFooter">
    <button class="btn btn-danger" @click="handleJoinEvent">
      <img src="../assets/images/goLive_Icon.png" />
      {{ $t('goLive') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'GoliveButtonComponents',
  props: ['room_id', 'channel'],
  data() {
    return {
      categoryNew: []
    }
  },
  methods: {
    handleJoinEvent() {
      this.$emit('handleJoinEvent')
    }
  },
  sockets: {}
}
</script>
